<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
	<center>
		<select multiple="multiple" class="multi-select" id="col_multi_select" name="meter-values">
			{{#each columns}}
				{{#if name}}<optgroup label="{{name}}">{{/if}}
				{{#each entries}}
				<option value="{{index}}"{{#if is_selected}} selected{{/if}}>{{name}}</option>
				{{/each}}
			{{/each}}
		</select>
	</center>
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<a class="btn btn-primary" id="js-save">{{TR "Speichern"}}</a>
</div>
